// import React from 'react'
// import { BsEmojiDizzyFill } from 'react-icons/bs'
import { CiCirclePlus } from 'react-icons/ci';
// import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { ProjectsEndpoints } from '../../Routes/api/Endpoints';
import HeaderDashboard from '../../components/Client/dashboardComponents/HeaderDashboard';
import LivraisonTable from '../../components/Client/livrableComponents/LivraisonTable';
import ImageContainerDisplay from '../../components/Client/projectsComponents/livraisonsComponents/ImageContainerDisplay';
import InputWysiwyg from '../../components/Utils/InputWysiwyg';
import MonBouton from '../../components/Utils/design-system/buttons/MonBouton';
import { useModal } from '../../context/ModalContext';
import { selectData } from '../../redux/features/userSliceWithTokenValidation';
import { usePostDataMutation } from '../../services/auth-services/AuthService';
import { useFetchProjectsQuery } from '../../services/auth-services/TacheService';


const VoirLivrable = () => {
  // const navigate = useNavigate();
  const user = useSelector(selectData);
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState("");
  const { closeModal } = useModal();
  const [images, setImages] = useState([]);
  const [captures, setCaptures] = useState([]);
  const [openInput, setOpenInput] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null); // Variable pour stocker l'ID du projet sélectionné
  const { data: projets } = useFetchProjectsQuery(ProjectsEndpoints.getProjects, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    skip: false,
  });
  const filteredProjects = projets && projets?.filter((proj) => (proj.user_id === user?.porteur_projet?.id) || (proj?.assigned_to_id === user?.id));

  const onProjectChange = (e) => {
    setSelectedProjectId(e.value);
  };
  console.log(filteredProjects);

  const [postData, { isLoading }] = usePostDataMutation();

  const handleImageUpload = (files) => {
    const uploadedImages = Array.from(files).map(file => URL.createObjectURL(file));
    const uploadImageSending = Array.from(files).map(file => file)
    setImages(prevImages => [...prevImages, ...uploadedImages]);
    setCaptures(prevImages => [...prevImages, ...uploadImageSending])
  };

  const handlePosteLivrable = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('coach_id', user?.id)
    formData.append('description', text);
    captures.forEach((capture, index) => {
      formData.append(`captures[${index}]`, capture);
    });

    postData({ endpoint: ProjectsEndpoints.ajoutLivraisonCoach, elementID: selectedProjectId, formData })
      .unwrap()
      .then((result) => {
        toast.success(result.message);
        // refetch();
        setText("");
        setCaptures([]);
        setImages([]);
        setSelectedProjectId(null)
        setOpenInput(false);
        setVisible(false)
      }).catch((error) => {
        console.log(error);
        toast.error(error);
      });
  }


  const handleRemoveImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };
  return (
    <div className='pt-6 px-6 livrables'>
      <HeaderDashboard />
      <div className='flex justify-Lbetween items-center mt-4 flex-wrap'>
        <p className='font-inter text-lg text-noir_300 pt-2'>La liste de mes livrables</p>
        {(user?.statut === "coach" || user?.statut === "coach-assistant") && <div className='px-2 max-md:px-0 pt-2'>
          <MonBouton children={"Ajouter un livrable"} couleurFond={"bg-white"} bordure={"border px-2 py-2 justify-center  rounded-full text-xs text-black/60"} icone={<CiCirclePlus className='text-black/60' />} action={() => setVisible(true)} type={"button"} />
        </div>}
      </div>
      {filteredProjects && <LivraisonTable projets={filteredProjects} />}
      <div className="card flex justify-content-center">
        <Dialog header="Ajouter une livraison" visible={visible} style={{ width: '50vw' }} onHide={() => { if (!visible) return; setVisible(false); setSelectedProjectId(null) }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
          <div>
            {projets && <Dropdown
              value={selectedProjectId}
              options={filteredProjects}
              onChange={onProjectChange}
              optionLabel="titre"
              optionValue="id"
              placeholder="Sélectionnez un projet"
              className="w-full border"
            // dropdownIcon={true}
            />
            }
          </div>
          <div>
            <ImageContainerDisplay
              images={images}
              onRemoveImage={handleRemoveImage}
              height={"120px"}
              width={"300px"}
              margin={"10px"}
            />
            <InputWysiwyg
              text={text}
              setText={setText}
              onImageUpload={handleImageUpload}
              placeholder="Ajouter un livrable"
              height="150px"
              livrable={true}
              width="w-full"
              submit={handlePosteLivrable}
              isLoading={isLoading}
            />
          </div>
        </Dialog>
      </div>
    </div>
  )
}

export default VoirLivrable
